// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import PieChartController from "./pie_chart_controller"
application.register("pie-chart", PieChartController)

import IconPickerController from "./icon_picker_controller"
application.register("icon-picker", IconPickerController)

import DownloadController from "./download_controller"
application.register("download", DownloadController)

import InvokerController from "./invoker_controller"
application.register("invoker", InvokerController)

import PostMessageController from "./post_message_controller"
application.register("post-message", PostMessageController)
